var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.958984H513V342.959H0V0.958984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.958984H513V114.959H0V0.958984ZM0 228.959H513V342.959H0V228.959ZM203.5 118.859L210.2 135.459L227.8 136.459L213.8 147.359L218.5 165.059L203.5 155.159L188.5 165.059L193.2 147.359L179.2 136.459L196.8 135.459L203.5 118.859ZM308.5 118.859L315.2 135.459L332.8 136.459L318.8 147.359L323.5 165.059L308.5 155.159L293.5 165.059L298.2 147.359L284.2 136.459L301.8 135.459L308.5 118.859ZM256 148.559L262.7 165.159L280.3 166.159L266.3 177.059L271 194.759L256 184.859L241 194.759L245.7 177.059L231.7 166.159L249.3 165.159L256 148.559ZM203.5 178.259L210.2 194.859L227.8 195.859L213.8 206.759L218.5 224.359L203.5 214.459L188.5 224.359L193.2 206.759L179.2 195.859L196.8 194.859L203.5 178.259ZM308.5 178.259L315.2 194.859L332.8 195.859L318.8 206.759L323.5 224.359L308.5 214.459L293.5 224.359L298.2 206.759L284.2 195.859L301.8 194.859L308.5 178.259Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.958984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHn);
export default __webpack_public_path__ + "static/media/HN.a5c31882d2cfe470b529c043d5a8f9d0.svg";
export { ForwardRef as ReactComponent };